module.exports = require("@mui/material/Accordion");